<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-program-category-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('WISHLIST.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.name" v-if="locale == 'hu'">
                <input type="text" class="form-control" v-model="model.name_en" v-else>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('POST.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.COLOR') }}
            </label>
            <div class="col-md-6">
                <input type="color" class="form-control" v-model="model.color">
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4 control-label"></div>
            <div class="col-md-2" style="margin-top: .4em;">
                <label for="active" class="control-label">
                    <input type="checkbox" v-model="model.is_hidden" >
                    {{ $t('GENERAL.HIDDEN') }}
                </label>
            </div>
        </div>


    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/ProgramCategoryForm.vue